
import {defineComponent, ref} from "vue";
import {hideModal} from "@/core/helpers/dom";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "mobile-move-subscription-modal",
  props: {
    modalId: String,
    subscription: Object,
    mobiles: Array,
    mobileId: Number,
  },
  emits: {
    callback: () => true,
  },
  components: {},
  setup(props, { emit }) {
    const formRef = ref<null | HTMLFormElement>(null);
    const MobileMoveSubscriptionModal = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      mobile_id: props.mobileId
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate(() => {
        loading.value = true;

        ApiService.setHeader();
        const payload = {
          params: {
            subscriptionId: props.subscription?.id,
            mobileId: formData.value.mobile_id
          }
        }
        ApiService.post(`v1/backend/mobile/move-subscription`, payload)
            .then(() => {
              loading.value = false;
              emit('callback')
              hideModal(MobileMoveSubscriptionModal.value);
            })
            .catch(({response}) => {
              console.log(response);
            });
      });
    };

    return {
      formData,
      submit,
      formRef,
      loading,
      MobileMoveSubscriptionModal,
    };
  },
});
